/*
 * vue-table.js v1.0.10
 * (c) 2016 Rati Wannapanop
 * Released under the MIT License.
 */

/**
 * Pagination Mixin
 */
var paginationMixin = {
    props: {
        'wrapperClass': {
            type: String,
            default: function () {
                return 'ui right floated pagination menu'
            }
        },
        'disabledClass': {
            type: String,
            default: function () {
                return 'disabled'
            }
        },
        'pageClass': {
            type: String,
            default: function () {
                return 'item'
            }
        },
        'linkClass': {
            type: String,
            default: function () {
                return 'icon item'
            }
        },
        'icons': {
            type: Object,
            default: function () {
                return {
                    prev: 'left chevron icon',
                    next: 'right chevron icon'
                }
            }
        }
    },
    data: function () {
        return {
            tablePagination: null
        }
    },
    computed: {
        totalPage: function () {
            return this.tablePagination == null
                ? 0
                : this.tablePagination.last_page
        },
        isOnFirstPage: function () {
            return this.tablePagination == null
                ? false
                : this.tablePagination.current_page == 1
        },
        isOnLastPage: function () {
            return this.tablePagination == null
                ? false
                : this.tablePagination.current_page == this.tablePagination.last_page
        },
    },
    methods: {
        loadPage: function (page) {
            this.$dispatch('vuetable-pagination:change-page', page)
        },
        isCurrentPage: function (page) {
            return page == this.tablePagination.current_page
        }
    },
    events: {
        'vuetable:load-success': function (tablePagination) {
            this.tablePagination = tablePagination
        }
    },
}

/**
 * Vuejs component
 *  */
Vue.component('vuetable-pagination', {
    template: '<div class="{{wrapperClass}}">'
        + ' <a @click="loadPage(\'prev\')"'
        + ' class="{{linkClass}} {{isOnFirstPage ? disabledClass : \'\'}}">'
        + ' <i :class="icons.prev"></i>'
        + ' </a>'
        + ' <template v-for="n in totalPage">'
        + ' <a @click="loadPage(n+1)"'
        + ' class="{{pageClass}} {{isCurrentPage(n+1) ? disabledClass : \'\'}}">'
        + ' {{ n+1 }}'
        + ' </a>'
        + ' </template>'
        + ' <a @click="loadPage(\'next\')"'
        + ' class="{{linkClass}} {{isOnLastPage ? disabledClass : \'\'}}">'
        + ' <i :class="icons.next"></i>'
        + ' </a>'
        + ' </div>',
    mixins: [paginationMixin],
})

Vue.component('vuetable-pagination-dropdown', {
    template: '<div class="{{wrapperClass}}">'
        + '<a @click="loadPage(\'prev\')"'
        + ' class="{{linkClass}} {{isOnFirstPage ? disabledClass : \'\'}}">'
        + '<i :class="icons.prev"></i>'
        + '</a>'
        + '<select id="vuetable-pagination-dropdown" class="ui search dropdown" @change="selectPage($event)">'
        + '<template v-for="n in totalPage">'
        + '<option class="{{pageClass}}" value="{{n+1}}">'
        + 'Page {{n+1}}'
        + '</option>'
        + '</template>'
        + '</select>'
        + '<a @click="loadPage(\'next\')"'
        + ' class="{{linkClass}} {{isOnLastPage ? disabledClass : \'\'}}">'
        + '<i :class="icons.next"></i>'
        + '</a>'
        + '</div>',
    mixins: [paginationMixin],
    methods: {
        loadPage: function (page) {
            // update dropdown value
            if (page == 'prev' && !this.isOnFirstPage) {
                this.setDropdownToPage(this.tablePagination.current_page - 1)
            } else if (page == 'next' && !this.isOnLastPage) {
                this.setDropdownToPage(this.tablePagination.current_page + 1)
            }

            this.$dispatch('vuetable-pagination:change-page', page)
        },
        setDropdownToPage: function (page) {
            this.$nextTick(function () {
                document.getElementById('vuetable-pagination-dropdown').value = page
            })
        },
        selectPage: function (event) {
            this.$dispatch('vuetable-pagination:change-page', event.target.selectedIndex + 1)
        },
    },
    events: {
        'vuetable:load-success': function (tablePagination) {
            this.tablePagination = tablePagination
            this.setDropdownToPage(tablePagination.current_page)
        }
    },
})

Vue.component('vuetable', {
    template: '<div class="{{wrapperClass}}">'
        + '<table class="vuetable {{tableClass}}">'
        + '<thead>'
        + '<tr class="bg-primary">'
        + '<template v-for="field in fields">'
        + '<template v-if="field.visible">'
        + '<th v-if="isSpecialField(field.name)"  id="{{field.name}}" data-toggle="true" class="{{field.titleClass || \'\'}}">'
        + '{{{field.title || \'\'}}}<input type="checkbox" v-model="showDelete"> Delete'
        + '</th>'
        + '<th v-else'
        + ' @click="orderBy(field)"'
        + ' id="_{{field.name}}"'
        + 'data-hide="{{field.dataHide}}" '
        + ' class="{{field.titleClass || \'\'}} {{isSortable(field) ? \'sortable\' : \'\'}}">'
        + ' {{{getTitle(field) | capitalize}}} '
        + '<i v-if="isCurrentSortField(field)" class="{{ sortIcon }}"></i>'
        + '</th>'
        + '</template>'
        + '</template>'
        + '</tr>'
        + '</thead>'
        + '<tbody v-cloak>'
        + '<tr v-for="item in tableData" @click="onRowClicked(item, $event)">'
        + '<template v-if="onRowChanged(item)"></template>'
        + '<template v-for="field in fields">'
        + '<template v-if="field.visible">'
        + '<template v-if="isSpecialField(field.name)">'
        + '<td v-if="field.name == \'__actions\'" class="vuetable-actions {{field.dataClass}}">'
        + '<template v-for="action in itemActions">'
        + '<a v-if="isDeleteAction(action.name)" v-show="showDelete" class="{{ action.class }}" @click="callAction(action.name, item)">'
        + '<i class="{{ action.icon }}"></i> {{{ action.label }}} '
        + '</a>'
        + '<a v-if="isNotDeleteAction(action.name)" class="{{ action.class }}" @click="callAction(action.name, item)">'
        + '<i class="{{ action.icon }}"></i> {{{ action.label }}} '
        + '</a>'
        + '</template>'
        + '</td>'
        + '</template>'
        + '<template v-else>'
        + '<td v-if="hasCallback(field)" class="{{field.dataClass}}">'
        + '{{{ callCallback(field, item) }}}'
        + '</td>'
        + '<td v-else class="{{field.dataClass}}">'
        + '{{{ getObjectValue(item, field.name, "") }}}'
        + '</td>'
        + '</template>'
        + '</template>'
        + '</template>'
        + '</tr>'
        + '</tbody>'
        + '</table>'
        + '<div v-if="showPagination" class="vuetable-pagination {{paginationClass}}">'
        + '<div class="vuetable-pagination-info {{paginationInfoClass}}"'
        + ' v-html="paginationInfo">'
        + '</div>'
        + '<div v-show="tablePagination && tablePagination.total > 0" '
        + 'class="vuetable-pagination-component {{paginationComponentClass}}">'
        + '<component v-ref:pagination :is="paginationComponent"></component>'
        + '</div>'
        + '</div>'
        + '</div>',
    props: {
        'wrapperClass': {
            type: String,
            default: function () {
                return null
            }
        },
        'tableWrapper': {
            type: String,
            default: function () {
                return null
            }
        },
        'tableClass': {
            type: String,
            default: function () {
                return 'ui blue striped selectable celled stackable attached table'
            }
        },
        'loadingClass': {
            type: String,
            default: function () {
                return 'loading'
            }
        },
        'dataPath': {
            type: String,
            default: function () {
                return 'data'
            }
        },
        'paginationPath': {
            type: String,
            default: function () {
                return 'links.pagination'
            }
        },
        'fields': {
            type: Array,
            required: true
        },
        'apiUrl': {
            type: String,
            required: true
        },
        'sortOrder': {
            type: Object,
            default: function () {
                return {
                    field: '',
                    direction: 'asc'
                }
            }
        },
        'perPage': {
            type: Number,
            coerce: function (val) {
                return parseInt(val);
            },
            default: function () {
                return 10
            }
        },
        'ascendingIcon': {
            type: String,
            default: function () {
                return 'blue chevron up icon'
            }
        },
        'descendingIcon': {
            type: String,
            default: function () {
                return 'blue chevron down icon'
            }
        },
        'appendParams': {
            type: Array,
            default: function () {
                return []
            }
        },
        'showPagination': {
            type: Boolean,
            default: function () {
                return true
            }
        },
        'paginationComponent': {
            type: String,
            default: function () {
                return 'vuetable-pagination'
            }
        },
        'paginationInfoTemplate': {
            type: String,
            default: function () {
                return "Displaying {from} to {to} of {total} items"
            }
        },
        'paginationInfoNoDataTemplate': {
            type: String,
            default: function () {
                return 'No relevant data'
            }
        },
        'paginationClass': {
            type: String,
            default: function () {
                return 'ui bottom attached segment grid'
            }
        },
        'paginationInfoClass': {
            type: String,
            default: function () {
                return 'left floated left aligned six wide column'
            }
        },
        'paginationComponentClass': {
            type: String,
            default: function () {
                return 'right floated right aligned six wide column'
            }
        },
        itemActions: {
            type: Array,
            default: function () {
                return []
            }
        },
        queryParams: {
            type: Object,
            default: function () {
                return {
                    sort: 'sort',
                    page: 'page',
                    perPage: 'per_page'
                }
            }
        },
        loadOnStart: {
            type: Boolean,
            default: function () {
                return true
            }
        },
    },
    data: function () {
        return {
            eventPrefix: 'vuetable:',
            tableData: null,
            tablePagination: null,
            currentPage: 1,
            showDelete: false
        }
    },
    computed: {
        sortIcon: function () {
            return this.sortOrder.direction == 'asc' ? this.ascendingIcon : this.descendingIcon
        },
        paginationInfo: function () {
            if (this.tablePagination == null || this.tablePagination.total == 0) {
                return this.paginationInfoNoDataTemplate
            }

            return this.paginationInfoTemplate
                .replace('{from}', this.tablePagination.from || 0)
                .replace('{to}', this.tablePagination.to || 0)
                .replace('{total}', this.tablePagination.total || 0)
        },
    },
    methods: {
        normalizeFields: function () {
            var self = this
            var obj
            this.fields.forEach(function (field, i) {
                if (typeof (field) === 'string') {
                    obj = {
                        name: field,
                        title: self.setTitle(field),
                        titleClass: '',
                        dataClass: '',
                        callback: null,
                        visible: true,
                        dataHide: '',
                        dataToggle: ''
                    }
                } else {
                    obj = {
                        name: field.name,
                        title: (field.title === undefined) ? self.setTitle(field.name) : field.title,
                        sortField: field.sortField,
                        titleClass: (field.titleClass === undefined) ? '' : field.titleClass,
                        dataClass: (field.dataClass === undefined) ? '' : field.dataClass,
                        callback: (field.callback === undefined) ? '' : field.callback,
                        visible: (field.visible === undefined) ? true : field.visible,
                        dataHide: (field.dataHide === undefined) ? true : field.dataHide,
                        dataToggle: (field.dataToggle === undefined) ? true : field.dataToggle
                    }
                }
                self.fields.$set(i, obj)
            })
        },
        setTitle: function (str) {
            if (this.isSpecialField(str)) {
                return ''
            }

            return this.titleCase(str)
        },
        titleCase: function (str) {
            return str.replace(/\w+/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        },
        loadData: function () {
            var wrapper = document.querySelector(this.tableWrapper)
            this.showLoadingAnimation(wrapper)

            var params = [
                this.queryParams.sort + '=' + this.getSortParam(),
                this.queryParams.page + '=' + this.currentPage,
                this.queryParams.perPage + '=' + this.perPage
            ]

            var url = this.apiUrl + '?' + params.join('&')
            if (this.appendParams.length > 0) {
                url += '&' + this.appendParams.join('&')
            }
            var self = this
            this.$http.get(url)
                .then(function (response) {
                    self.tableData = self.getObjectValue(response.data, self.dataPath, null)
                    self.tablePagination = self.getObjectValue(response.data, self.paginationPath, null)
                    self.dispatchEvent('load-success', response)
                    self.broadcastEvent('load-success', self.tablePagination)

                    self.hideLoadingAnimation(wrapper)
                }, function (response) {
                    self.dispatchEvent('load-error', response)
                    self.broadcastEvent('load-error', response)

                    self.hideLoadingAnimation(wrapper)
                })
        },
        showLoadingAnimation: function (wrapper) {
            if (wrapper !== null) {
                this.addClass(wrapper, this.loadingClass)
            }
            this.dispatchEvent('loading')
        },
        hideLoadingAnimation: function (wrapper) {
            if (wrapper !== null) {
                this.removeClass(wrapper, this.loadingClass)
            }
            this.dispatchEvent('loaded')
        },
        getTitle: function (field) {
            if (typeof field.title === 'undefined') {
                return field.name.replace('.', ' ')
            }
            return field.title
        },
        getSortParam: function () {
            if (!this.sortOrder || this.sortOrder.field == '') {
                return ''
            }

            var fieldName = (typeof this.sortOrder.sortField === 'undefined')
                ? this.sortOrder.field
                : this.sortOrder.sortField

            return fieldName + '|' + this.sortOrder.direction
        },
        addClass: function (el, className) {
            if (el.classList)
                el.classList.add(className)
            else
                el.className += ' ' + className
        },
        removeClass: function (el, className) {
            if (el.classList)
                el.classList.remove(className)
            else
                el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ')
        },
        dispatchEvent: function (eventName, args) {
            this.$dispatch(this.eventPrefix + eventName, args)
        },
        broadcastEvent: function (eventName, args) {
            this.$broadcast(this.eventPrefix + eventName, args)
        },
        orderBy: function (field) {
            if (!this.isSortable(field)) {
                return
            }

            if (this.sortOrder.field == field.name) {
                // change sort direction
                this.sortOrder.direction = this.sortOrder.direction == 'asc' ? 'desc' : 'asc'
            } else {
                // reset sort direction
                this.sortOrder.direction = 'asc'
            }
            this.sortOrder.field = field.name
            this.sortOrder.sortField = field.sortField
            this.currentPage = 1    // reset page index
            this.loadData();
        },
        isSortable: function (field) {
            return !(typeof field.sortField == 'undefined')
        },
        isCurrentSortField: function (field) {
            if (!this.isSortable(field)) {
                return false
            }

            return this.sortOrder.field == field.name
        },
        gotoPreviousPage: function () {
            if (this.currentPage > 1) {
                this.currentPage--
                this.loadData()
            }
        },
        gotoNextPage: function () {
            if (this.currentPage < this.tablePagination.last_page) {
                this.currentPage++
                this.loadData()
            }
        },
        gotoPage: function (page) {
            if (page != this.currentPage && (page > 0 && page <= this.tablePagination.last_page)) {
                this.currentPage = page
                this.loadData()
            }
        },
        isSpecialField: function (fieldName) {
            return fieldName.startsWith('__')
        },
        isDeleteAction: function (fieldName) {
            return fieldName.startsWith('delete-')
        },
        isNotDeleteAction: function (fieldName) {
            return !fieldName.startsWith('delete-')
        },
        hasCallback: function (item) {
            return item.callback ? true : false
        },
        callCallback: function (field, item) {
            if (!this.hasCallback(field))
                return

            var args = field.callback.split('|')
            var func = args.shift()

            if (typeof this.$parent[func] == 'function') {
                return (args.length > 0)
                    ? this.$parent[func].apply(this.$parent, [this.getObjectValue(item, field.name)].concat(args))
                    : this.$parent[func].call(this.$parent, this.getObjectValue(item, field.name))
            }

            return null
        },
        getObjectValue: function (object, path, defaultValue) {
            defaultValue = (typeof defaultValue == 'undefined') ? null : defaultValue

            var obj = object
            if (path.trim() != '') {
                var keys = path.split('.')
                keys.forEach(function (key) {
                    if (typeof obj[key] != 'undefined' && obj[key] !== null) {
                        obj = obj[key]
                    } else {
                        obj = defaultValue;
                        return
                    }
                })
            }
            return obj
        },
        callAction: function (action, data) {
            this.$dispatch(this.eventPrefix + 'action', action, data)
        },
        addParam: function (param) {
            this.appendParams.push(param)
        },
        onRowChanged: function (dataItem) {
            this.$dispatch(this.eventPrefix + 'row-changed', dataItem)
            return true
        },
        onRowClicked: function (dataItem, event) {
            this.$dispatch(this.eventPrefix + 'row-clicked', dataItem, event)
            return true
        },

        updateRow: function (data) {
            var dataIndex = null;
            for (var key in this.tableData) {
                if (parseInt(this.tableData[key].id) === parseInt(data.id)) {
                    dataIndex = key;
                }
            }
            if (dataIndex) {
                this.tableData[dataIndex] = data;
                for (var property in this.tableData[dataIndex]) {
                    if (this.tableData[dataIndex].hasOwnProperty(property)) {
                        this.tableData[dataIndex][property] = data[property];
                    }
                }
            }
        }
    },
    events: {
        'vuetable-pagination:change-page': function (page) {
            if (page == 'prev') {
                this.gotoPreviousPage()
            } else if (page == 'next') {
                this.gotoNextPage()
            } else {
                this.gotoPage(page)
            }
        },
        'vuetable:reload': function () {
            this.loadData()
        },
        'vuetable:refresh': function () {
            this.currentPage = 1
            this.loadData()
        },
        'vuetable:update-row': function (data) {
            this.updateRow(data);
        },
        'vuetable:goto-page': function (page) {
            this.$emit('vuetable-pagination:change-page', page)
        },
    },
    created: function () {
        this.normalizeFields()
        if (this.loadOnStart) {
            this.loadData()
        }
    }
})
